import React from 'react';

import {Helmet} from 'views/module';

import {useParams} from 'views/module';

import CaregiverViewScene from 'views/scenes/caregiver/detail/CaregiverView';

const CaregiverView = (props) => {
  const params = useParams();

  const caregiverRn = params.caregiverRn;

  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <CaregiverViewScene
        caregiverRn={caregiverRn}
      />
    </>
  );
};

export default CaregiverView;
